
import React, { useState, useEffect, useRef } from 'react';
import Loader from './components/CustomComponents/Loader';
import RouterLayout from './router';
import { BrowserRouter as Router } from 'react-router-dom';
import 'animate.css';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/store'; // Import the store and persistor from your Redux storeimport { copyUrlAndSave } from './utils/copyUrlAndSave';
import { copyUrlAndSave } from './utils';
import DisableRightClickHOC from './disableRightClickHOC';
import { clearStorageExceptKey } from './utils';
import { HotKeys } from 'react-hotkeys';
import ScrollTop from './components/CustomComponents/ScrollTop';
import { ISDEV_ENV } from '../src/network/URLConstants';
import { useIdleTimer } from 'react-idle-timer'
import { fetchConfigarationData, retrieveData } from './helpers/utils/Utils';
import { ACCEPT_E_SIGN_AGGREMENT, COVERED_BY_KUDZU, GET_ESIGN_AGREEMENT, GET_ESIGN_STATUS, GET_USER_PORFIE_INFO, SAVINGS_HABIT, SPENDING_ALERT, STATUS_SUCCESS_CODE, VALIDATE_AUTH_USER, END_SESSION, SAVING_CARD_CODE } from "./network/URLConstants";
import { useTranslation } from "react-i18next";
import Cookies from 'js-cookie';

import { GetApiHeadersWithBearer, GetRequest, PostRequest, endSessionGetRequest } from './network/NetworkUtils';
import { useOidcAccessToken, useOidc, useOidcUser } from "@axa-fr/react-oidc";
import TourGuide from './components/CustomComponents/ToolTipTour';
import SmioneCard from './components/Home/SmioneCard';
import SmiOneSpendsAndLoad from './components/Home/SmiOneSpendsAndLoad';
const appConfigData = await fetchConfigarationData();

function App() {
  const { t } = useTranslation();
  const { user } = useOidcUser();
  const { logout, login } = useOidc();
  const [isLoading, setIsLoading] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const { accessToken, accessTokenPayload } = useOidcAccessToken()
  const dispatch = useDispatch();
  const accessTokenToApi = useSelector(state => state.accessToken);
  const cards = useSelector(state => JSON.parse(state.userCards));
  // const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const isB2c = useSelector(state => state.preferredIdentity);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const stepIndex = useSelector((state) => state?.toolTipstepIndex); 
  const [toolTipRun, setToolTipRun] = useState(false);
  const smiOneTrue = useSelector((state) => state.smiOneAccountTrue);
  const SideBarStatus = useSelector(state => state.isSideBarOpen);
  const [screen, setScreen] = useState(0);
  const limitRef = useRef(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const anyInAppNotifications = useSelector(state => state.anyInAppNotifications);
 


  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(()=>{
    if(cards && cards?.length > 0 && smiOneTrue) {
      if(smiOneTrue) {
        limitRef.current = 0;
  
    const scrollStep = 1;
    const scrollAutomatically = () => {
      if (limitRef.current < -2) {
          window.scrollBy({
            top: scrollStep,
            left: 0,
            behavior: "smooth",
        });
        limitRef.current -= 1;
      } else {
        clearInterval(interval);
      }
    };
    const interval = setInterval(scrollAutomatically, 100);
  
    return () => clearInterval(interval);
      }
          const productTourTooltipValue = `homeTourTooltip${cards[0].CardKey}`;
          const savingsNewClicked = Cookies.get(productTourTooltipValue);
          if(!savingsNewClicked){
            setToolTipRun(true);
          } else {
            setToolTipRun(false);
          }
      }
  })

  useEffect(()=>{
    setScreen(window.innerWidth)
  },[window.innerWidth])
  

  useEffect (()=>{
    if(cards && smiOneTrue){
      const productTourTooltipValue = `homeTourTooltip${cards[0].CardKey}`;
      const savingsNewClicked = Cookies.get(productTourTooltipValue);
      if(!savingsNewClicked) {
        setToolTipRun(false);
        setTimeout(() => setToolTipRun(true), 1100);
      } 
    }
  },[window.innerWidth])

  useEffect(() => {
    if(cards && smiOneTrue) {
    const navbars  = document.querySelector(".nav-bar");
    const insights = document.querySelector(".insights")
    const productTourTooltipValue = `homeTourTooltip${cards[0].CardKey}`;
    const savingsNewClicked = Cookies.get(productTourTooltipValue);
    const cardContent = document.querySelector(".animate__animated")

    if (toolTipRun && !savingsNewClicked && !SideBarStatus) {
      document.body.style.overflow = "hidden";
       if(navbars) navbars.style.pointerEvents = "none";
       if(insights) insights.style.pointerEvents = "none"
       if(cardContent) cardContent.style.pointerEvents = "none"
       
    } else {
      document.body.style.overflow = "";
      if(navbars) navbars.style.pointerEvents = "";
      if(insights) insights.style.pointerEvents = ""
      if(cardContent) cardContent.style.pointerEvents = ""
    }
  }
  }, [toolTipRun, cards]);

  const handleNextStep = () => {
    let stepCheck = 0;
    if(cards && cards?.[0].Balance <= 0) {
      stepCheck = firstSteps.length-1;
    } else {
      stepCheck = nextSteps.length-1;
    }
    if (stepIndex != null && stepIndex === stepCheck) {
      const productTourTooltipValue = `homeTourTooltip${cards[0].CardKey}`;
      Cookies.set(productTourTooltipValue, true, { expires: 1825 });
      setToolTipRun(false);
    } else {
      const nextStepIndex = stepIndex + 1;
      dispatch({
        type: "HOME_TOOLTIP_TOUR_NEXT_STEP",
        payload: { toolTipstepIndex: nextStepIndex },
      });
    }
  };

  useEffect(() => {
    if(cards && smiOneTrue && !isLoading){
    const productTourTooltipValue = `homeTourTooltip${cards[0].CardKey}`;
          const savingsNewClicked = Cookies.get(productTourTooltipValue);
          if(!savingsNewClicked){
        setToolTipRun(false); // Reset tooltip
        setTimeout(() => setToolTipRun(true), 3000);
      } // Restart tooltip after a small delay
    }
      }, [window.location.pathname, isLoading]);

  
   const nextSteps = [
    {
      target: ".smiOneCard",
      content: (
        <div className='font-hanken-grotesk text-[14px] font-[700] text-[#FFFFFF]'>
          <p className="text-left">View your smiONE card transaction history and spending insights here.</p>
          <div className="flex justify-end mt-[10px]">
            <span className="underline" onClick={handleNextStep} style={buttonStyle}>
              {t('ok_got_it')}
            </span>
          </div>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".insight-tooltip",
      content: (
        <div className='font-hanken-grotesk text-[14px] font-[700] text-[#FFFFFF]'>
          <p className="text-left">View your latest smiONE account insights here!</p>
          <div className="flex justify-end mt-[10px]">
            <span className="underline" onClick={handleNextStep} style={buttonStyle}>
              {t('ok_got_it')}
            </span>
          </div>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
    }
  ]
  const firstSteps = [
        {
          target: ".smiOneCard",
          content: (
            <div className='font-hanken-grotesk text-[14px] font-[700] '>
              <p className="text-left">View your smiONE card transaction history and spending insights here.</p>
              <div className="flex justify-end mt-[10px]">
                <span className="undeline" onClick={handleNextStep} style={buttonStyle}>
                  {t('ok_got_it')}
                </span>
              </div>
            </div>
          ),
          placement: "bottom",
          disableBeacon: true,
        },
        {
          target: ".add-money-tooltip",
          content: (
            <div className='font-hanken-grotesk text-[14px] font-[700]'>
              <p className="text-left">Get started by adding funds to your smiONE account!</p>
              <div className="flex justify-end mt-[10px]">
                <span className="undeline" onClick={handleNextStep} style={buttonStyle}>
                  {t('ok_got_it')}
                </span>
              </div>
            </div>
          ),
          placement: "bottom",
          disableBeacon: true,
        },
        {
          target: ".insight-tooltip",
          content: (
            <div className='font-hanken-grotesk text-[14px] font-[700]'>
              <p className="text-left">View your latest smiONE account insights here!</p>
              <div className="flex justify-end mt-[10px]">
                <span className="undeline" onClick={handleNextStep} style={buttonStyle}>
                  {t('ok_got_it')}
                </span>
              </div>
            </div>
          ),
          placement: "bottom",
          disableBeacon: true,
        }
      ]

  useEffect(() => {
    if (kudzuPlusTrue) {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }, [kudzuPlusTrue]);

  useEffect(() => {
    removeTrailingHash();
  }, [window.location.href]);
 
  function removeTrailingHash() {
    var currentUrl = window.location.href;
    if (currentUrl.endsWith('#')) {
      var newUrl = currentUrl.slice(0, -1);
      window.location.href = newUrl;
    }
  }
  useEffect(() => {
    if (cards != null && cards.find((item) => (item.AccountTypeBit63 == SAVING_CARD_CODE))) {
      const savingsAvailablePayload = { savingsAccontAvailable: true };
      dispatch({ type: 'SAVINSGS_AVAILABLE', payload: savingsAvailablePayload });
    } else {
      const savingsAvailablePayload = { savingsAccontAvailable: false };
      dispatch({ type: 'SAVINSGS_AVAILABLE', payload: savingsAvailablePayload });
    }


    if (accessToken && accessToken !== null && accessToken !== "") {
      const accessTokenPayload = { accessToken: accessToken };
      dispatch({ type: 'ACCESS_TOKEN', payload: accessTokenPayload });

      const twoFactAuthenticationDone = { twoFactAuthenticationDone: false }
      dispatch({ type: 'TWOFACT_DONE', payload: twoFactAuthenticationDone });
    }
  }, [accessToken])

  const handleOnIdle = event => {
    if (accessToken != null) {
      handleLogout()
    }
  }

  const handleOnActive = event => {
  }

  const handleOnAction = (event) => {
  }
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * appConfigData.IDLE_TIME,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })
  const handleLogout = async () => {
    sessionStorage.removeItem('plusModalClosedHome');
    if (!global.isLoggedIn) {
      return
    }
    global.isLoggedIn = false
    await logout()
    logoutManually();
    const deviceIdKey = 'updatedDeviceId';
    clearStorageExceptKey(sessionStorage, deviceIdKey);
    clearStorageExceptKey(localStorage, deviceIdKey);
    store.dispatch({ type: 'LOGOUT' });
    const loginPayload = { isLoggedIn: false };
    dispatch({ type: 'LOG_IN', payload: loginPayload });
  }

  useEffect(() => {
    // Simulating an asynchronous operation
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  const keyMap = {
    disableDevTools: ['f12', 'ctrl+shift+i', 'ctrl+shift+c', 'ctrl+shift+j', 'ctrl+u']
  };
  const handlers = {
    disableDevTools: (event) => {
      event.preventDefault();
    }
  };

  //*****this below commented code will give alert when refresh page and  delete user data */

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);




  if (accessTokenPayload) {
    const targetTimestamp = accessTokenPayload.exp;
    const currentTime = Math.floor(Date.now() / 1000); // Convert current time to Unix timestamp
    console.log('targetTimestamp', targetTimestamp)
    console.log('currentTime', currentTime)
    console.log('timeDifferenceInSeconds', targetTimestamp - currentTime)

    const timeDifferenceInSeconds = targetTimestamp - currentTime;
    // const timeDifferenceInSeconds = 32;

    if (timeDifferenceInSeconds < appConfigData.REFRESH_TIME_BEFORE_TOKENS_EXPIRATION_IN_SECOND) {
      handleLogout()
    }
  }


  const logoutManually = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var url = END_SESSION(isB2c,appConfigData.AUTH_URL,appConfigData.B2C_END_SESSION_URL ,appConfigData.CLIENT_ID, accessTokenToApi, appConfigData.POST_LOGOUT_REDIRECT_URI);
    window.location.replace(url);
  }
  const isSessionExpired = () => {

    return false; // Placeholder implementation
  };


  return (
    // <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <Router>
        {/* <ScrollTop /> */}
        {
           screen < 600 && !SideBarStatus && !anyInAppNotifications && (
            <TourGuide
            joyRideId="fromHome"
              steps={cards && cards?.[0]?.Balance <= 0.0000 ? firstSteps : nextSteps}
              handleNextStep={handleNextStep}
              stepIndex={stepIndex}
              toolTipRun={toolTipRun}
              backgroundClr='rgb(41, 101, 251)'
              textColor='#fff'
            />
          )
        }
        {
          screen > 600 && !anyInAppNotifications && (
            <TourGuide
              joyRideId="fromHome"
              steps={cards && cards?.[0]?.Balance <= 0.0000 ? firstSteps : nextSteps}
              handleNextStep={handleNextStep}
              stepIndex= {stepIndex}
              toolTipRun={toolTipRun}
              backgroundClr='rgb(41, 101, 251)'
              textClr='#fff'
            />
          )
        }
        <HotKeys keyMap={keyMap} handlers={handlers}>
          {/* <Header /> */}
          {isLoading ? <Loader /> : <RouterLayout />}
        </HotKeys>
      </Router>
    </PersistGate>
    // </Provider>
  );
}

const buttonStyle = {
  backgroundColor: "none",
  border: "none",
  cursor: "pointer",
  marginTop: "10px",
};

export default ISDEV_ENV ? App : DisableRightClickHOC(App);
